import React from "react";

/**
 * ChillRefer Logo — uses the brand wordmark image.
 *
 * Props:
 *  size: "sm" | "md" (default) | "lg"
 *  className: extra classes
 */
const Logo = ({ size = "md", className = "" }) => {
  const heights = { sm: 28, md: 36, lg: 48 };
  const h = heights[size] || heights.md;

  return (
    <div
      className={className}
      style={{ display: "inline-flex", alignItems: "center" }}
      data-testid="app-logo"
    >
      <img
        src="/logo_full.png"
        alt="ChillRefer"
        height={h}
        style={{ height: `${h}px`, width: "auto", flexShrink: 0 }}
      />
    </div>
  );
};

export default Logo;
